import { BLOG_ARTICLES } from "@config/blog-config";
import marty from "@public/static/story/martyna-soroka.png";
import { BlogHeroSection } from "@shared/components/blog/blog-hero-section";
import { IntroSection } from "@shared/components/blog/intro-section";
import { MainSection } from "@shared/components/blog/main-section";
import { Sidebar } from "@shared/components/blog/sidebar";
import { useLocale } from "@translations/locale-context";
import { StaticImage } from "@ui/components/image/static-image";
import { useTranslation } from "next-i18next";
import React, { FC } from "react";

const ContentCs: FC = () => (
    <>
        <h2 className="ui-typo-h5 mb-10">Kdo jsi?</h2>
        <p className="mb-6">
            Jmenuji se&nbsp;Martyna, pocházím z&nbsp;města uprostřed Polska, 150&nbsp;km od&nbsp;Poznaně, kde jsem
            později studovala. Vždycky jsem ráda cestovala a&nbsp;věděla, že v&nbsp;budoucnu chci bydlet
            v&nbsp;zahraničí a&nbsp;poznávat cizí kultury. Že to bude zrovna Česká republika, by mě ale nikdy nenapadlo.
        </p>
        <p className="mb-6">
            Bylo pro mě samozřejmostí, že během studia pojedu na&nbsp;Erasmus. Po&nbsp;semestru ve&nbsp;Slovinsku jsem
            se&nbsp;hned přihlásila na&nbsp;Erasmus v&nbsp;Praze. Poslední semestr jsem dodělala na&nbsp;ČVUT, kde jsem
            se&nbsp;naučila česky a&nbsp;po&nbsp;půl roce jsem získala i&nbsp;práci s&nbsp;češtinou.
        </p>
        <p className="mb-6">
            Čas po&nbsp;práci trávím spoustou koníčků, hlavně sportováním a&nbsp;učením se&nbsp;nových věcí.
            Ze&nbsp;všech sportů, které jsem začala dělat, mi nejdéle vydrželo běhání s&nbsp;mapou po&nbsp;lese
            a&nbsp;lezení. Kromě toho ráda cestuji.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Co bylo před UX Fans?</h2>
        <p className="mb-6">
            Studovala jsem &bdquo;Aplikace Internetu Věcí&ldquo;, kde jsem se&nbsp;naučila základy programování,
            síťování a&nbsp;online marketingu. Zjistila jsem, že IT mě hodně baví, a&nbsp;chtěla jsem pracovat jako IT
            Project Manager. Hned po&nbsp;škole jsem začala pracovat v&nbsp;IT Help Desku s&nbsp;češtinou, a&nbsp;po
            8&nbsp;měsících jsem se&nbsp;rozhodla odstěhovat do&nbsp;Česka. Jako cizinka jsem moc nevěděla, kde hledat
            práci, a&nbsp;tak jsem zkusila největšího zaměstnavatele na&nbsp;trhu (ŠKODA - IT oddělení). Po&nbsp;roce
            práce v&nbsp;Mladé Boleslavi jsem zjistila, že mě korporát nebaví, takže jsem dala výpověď a&nbsp;zkusila to
            v&nbsp;UX Fans.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Co tě do UX Fans přivedlo?</h2>
        <p className="mb-6">
            Dá se&nbsp;říct, že do&nbsp;UX Fans jsem se&nbsp;dostala díky orienťáku. Ve&nbsp;společné skupině orienťáků
            z&nbsp;Liberecka se&nbsp;objevila zpráva od&nbsp;Škoďáka, že v&nbsp;UX Fans, kde pracuje, hledají IT
            projekťáka. Byla to přesně ta pozice, kterou jsem hledala. Z&nbsp;pohovoru jsem měla velmi dobrý pocit. Moc
            se&nbsp;mi líbilo okolí a&nbsp;prostředí, navíc pár členů týmu bylo mými kamarády. Po&nbsp;čtyřech letech
            mám stále stejný pocit, akorát teď už jsou mými kamarády všichni.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Jaká je tvoje role v UX Fans?</h2>
        <p className="mb-6">
            Začala jsem jako projektová manažerka, ale stejně tak jako ve&nbsp;volném čase, i&nbsp;v práci ráda zkouším
            a&nbsp;učím se&nbsp;nové věci. Prošla jsem si několika kurzy programování, a&nbsp;nyní je mojí hlavní rolí
            front-end vývojářka. Kromě kódování ráda organizuji teambuildingové akce.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Baví tě být součástí UX Fans?</h2>
        <p>
            Baví mě trávit každý den s&nbsp;fajn lidmi, kteří mají rádi to, co dělají, a&nbsp;jsou ochotni sdílet svoje
            zkušenosti s&nbsp;ostatními. Oceňuji, že se&nbsp;mohu vyvíjet přesně tím směrem, kterým chci, a&nbsp;nejsem
            omezena v&nbsp;rámci konkrétní pracovní pozice. Také si vážím kolektivu, se&nbsp;kterým si večer u&nbsp;piva
            nebo ohně máme o&nbsp;čem povídat a&nbsp;nebo si jdeme během dne společně zaběhat.
        </p>
    </>
);

const ContentEn: FC = () => (
    <>
        <h2 className="ui-typo-h5 mb-10">Who are you?</h2>
        <p className="mb-6">
            My name is Martyna, I come from a&nbsp;town in the middle of Poland, 150&nbsp;km from Poznan, where I later
            studied. I have always loved traveling and knew that, in the future, I want to live abroad and experience
            foreign cultures. But I never thought that it would be the Czech Republic.
        </p>
        <p className="mb-6">
            It was a&nbsp;given that I would go on Erasmus during my studies. After a&nbsp;semester in Slovenia, I
            immediately applied for Erasmus in Prague. I finished my last semester at the Czech Technical University,
            where I learned Czech and after half a&nbsp;year I got a&nbsp;job with Czech.
        </p>
        <p className="mb-6">
            I spend my time after work doing a&nbsp;lot of hobbies, especially sports and learning new things. Of all
            the sports I started doing, running with a&nbsp;map in the woods and climbing stuck with me the longest.
            Other than that, I love to travel.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What was before UX Fans?</h2>
        <p className="mb-6">
            I studied &quot;Internet of Things Applications&quot; where I learned the basics of programming, networking
            and online marketing. I found that I really enjoyed IT and wanted to work as an&nbsp;IT Project Manager.
            Right after school I started working at an&nbsp;IT Help Desk with Czech language, and after 8 months I
            decided to move to the Czech Republic. As a&nbsp;foreigner, I didn&apos;t really know where to look for
            a&nbsp;job, so I tried the biggest employer on the market (ŠKODA - IT department). After a&nbsp;year of
            working in Mladá Boleslav, I found out that I didn&apos;t enjoy the corporate world, so I quit my job and
            tried my hand at UX Fans.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What brought you to UX Fans?</h2>
        <p className="mb-6">
            You could say that I got into UX Fans thanks to orienteering. In a&nbsp;group of orienteers based around the
            Liberec area, Škoďák wrote that they were looking for an&nbsp;IT project manager. It was exactly the
            position I was looking for. I had a very good feeling about the interview. I really liked the surroundings
            and the environment, plus a&nbsp;couple of the team members were my friends. Four years later, I still have
            the same feeling, only now they are all my friends.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What is your role in UX Fans?</h2>
        <p className="mb-6">
            I started as a&nbsp;project manager, but just like in my free time, I also like to try and learn new things
            at work. I&apos;ve done a&nbsp;few coding courses, and now my main role is FE developer. Besides coding, I
            like to organize team building events.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Do you enjoy being part of UX Fans?</h2>
        <p>
            I enjoy spending every day with cool people who love what they do and are willing to share their experiences
            with others. I appreciate that I can evolve in the direction I want to and not be locked into
            a&nbsp;specific job role. I appreciate that I work with people I can go sit and talk over a&nbsp;beer with
            or go for a&nbsp;quick run during the day.
        </p>
    </>
);

export function MartynaSorokaStoryPage() {
    const { t } = useTranslation();
    const locale = useLocale();

    const sidebar = (
        <Sidebar
            buttonUrl="https://www.linkedin.com/in/martyna-soroka//"
            buttonText="LinkedIn"
            inCompanySince={t("story:martynaSoroka.inCompanySince")}
            position={t("story:martynaSoroka.position")}
            hashtags={BLOG_ARTICLES.find((a) => a.key === "martyna-soroka")?.hashtags}
        />
    );

    return (
        <main>
            <BlogHeroSection name="Martyna Soroka" title={t("story:martynaSoroka.title")}>
                <StaticImage
                    alt=""
                    imgClassName="!w-full object-contain"
                    src={marty}
                    width={583}
                    widths={[400, 400, 583, 448, 540, 583]}
                />
            </BlogHeroSection>
            <MainSection className="mb-12 md:mb-20">
                <IntroSection sidebar={sidebar}>
                    <div className="ui-typo-body">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
                </IntroSection>
                <div className="mt-12 flex flex-col justify-between border-t pt-12 xl:hidden">{sidebar}</div>
            </MainSection>
        </main>
    );
}
